import { i18n } from '@/locales';
import { validateTextWithHypen, currency, changeStartEndStringTimeZone, injectSeparatorTimeString, addDividerToMultipleTextField, getAddressData, formatDate, } from '@/utils';
import { fulfillmentState, timeZoneCode, } from '@/constants/global';
import { hubStatusOptionList, workerOneClickBaechaYnOptionList, sortByCodeOptionList, shareCallColorTypeOptionList, assignedWorkerLockTimeOptionList, orderShowTimeOptionList, isCustomerMessageServiceOptionList, } from '@/constants/hubManagement';
import { fulfillmentStatus } from '@/constants/operationSetting/operationSettingOptionList';
import dateFormatType from '@/constants/dateFormatType';
import { distanceProductCodeObj } from '@/constants/distanceProductCode';
import { formatPhoneNumber } from '@/utils/regularExpression';
import AddressFormVM from '@/view-model/AddressFormVM';
export default class Hub {
    _masterId;
    _name;
    _code;
    _addChargeApplyYn;
    _addDeliveryCharge;
    _addDeliveryChargeRate;
    _addCookingTime;
    _deliveryWorkYn;
    _callcenterCode;
    _useYn;
    _businessName;
    _businessNumber;
    _businessCondition;
    _businessType;
    _ceoName;
    _ceoPhone;
    _ceoEmail;
    _workingTime;
    _addressDong;
    _addressSiDo;
    _addressSiGunGu;
    _addressLi;
    _addressJibun;
    _addressRoad;
    _addressBuildingNumber;
    _addressBuildingName;
    _addressDetail;
    _withdrawableAmount;
    _baromoney;
    _depositBaromoney;
    // embed 가능한 리소스 List 중 VIRTUAL_BANK는 null로 들어올 수 있음
    _virtualBankDTO;
    _createdAt;
    _distributorId;
    _distributorDTO;
    _hubRepresentativePhone;
    _phone;
    _fax;
    _hubConfigurationDTO;
    _workerOneClickBaechaYn;
    _laterUseYn;
    _distanceProduct;
    _withdrawBankDTO;
    _withdrawalBankCode;
    _withdrawalBankAccount;
    _withdrawalBankOwner;
    _hubAdjustmentRateDTO;
    _headQuarterAdjustmentRateDTO;
    constructor({ code, masterId, name, addChargeApplyYn, addDeliveryCharge, addDeliveryChargeRate, addCookingTime, 
    // 상호명
    businessName, 
    // 사업자 등록번호
    businessNumber, 
    // 업태
    businessCondition, 
    // 종목
    businessType, 
    // 대표자명
    ceoName, 
    // 이메일
    ceoEmail, 
    // 연락처
    ceoPhone, addressSiDo, addressSiGunGu, addressDong, addressLi, addressJibun, addressRoad, addressBuildingNumber, addressBuildingName, addressDetail, useYn, workingTime, depositBaromoney, baromoney, createdAt, deliveryWorkYn, callcenterCode, distributorId, distributorDTO, 
    // 라이더앱 노출번호
    hubRepresentativePhone, 
    // 상점 노출번호
    phone, fax, hubConfigurationDTO, workerOneClickBaechaYn, laterUseYn, distanceProduct, withdrawableAmount, virtualBankDTO, withdrawBankDTO, withdrawalBankCode, withdrawalBankOwner, withdrawalBankAccount, hubAdjustmentRateDTO, headQuarterAdjustmentRateDTO, } = {}) {
        this._code = code;
        this._masterId = masterId;
        this._name = name;
        this._addChargeApplyYn = addChargeApplyYn === 'Y';
        this._addDeliveryCharge = addDeliveryCharge;
        this._addDeliveryChargeRate = addDeliveryChargeRate;
        this._addCookingTime = addCookingTime;
        this._deliveryWorkYn = deliveryWorkYn;
        this._businessName = businessName;
        this._businessNumber = businessNumber;
        this._businessCondition = businessCondition;
        this._businessType = businessType;
        this._ceoName = ceoName;
        this._ceoPhone = ceoPhone;
        this._ceoEmail = ceoEmail;
        this._addressSiDo = addressSiDo;
        this._addressSiGunGu = addressSiGunGu;
        this._addressDong = addressDong;
        this._addressLi = addressLi;
        this._addressJibun = addressJibun;
        this._addressRoad = addressRoad;
        this._addressBuildingNumber = addressBuildingNumber;
        this._addressBuildingName = addressBuildingName;
        this._addressDetail = addressDetail;
        this._useYn = useYn;
        this._businessNumber = businessNumber;
        this._workingTime = workingTime;
        this._withdrawableAmount = withdrawableAmount;
        this._virtualBankDTO = virtualBankDTO;
        this._baromoney = baromoney;
        this._depositBaromoney = depositBaromoney;
        this._createdAt = createdAt;
        this._deliveryWorkYn = deliveryWorkYn;
        this._callcenterCode = callcenterCode;
        this._distributorId = distributorId;
        this._distributorDTO = distributorDTO;
        this._hubRepresentativePhone = hubRepresentativePhone;
        this._phone = phone;
        this._fax = fax;
        this._hubConfigurationDTO = hubConfigurationDTO;
        this._workerOneClickBaechaYn = workerOneClickBaechaYn;
        this._laterUseYn = laterUseYn;
        this._distanceProduct = distanceProduct;
        this._callcenterCode = callcenterCode;
        this._withdrawBankDTO = withdrawBankDTO;
        this._withdrawalBankCode = withdrawalBankCode;
        this._withdrawalBankAccount = withdrawalBankAccount;
        this._withdrawalBankOwner = withdrawalBankOwner;
        this._hubAdjustmentRateDTO = hubAdjustmentRateDTO;
        this._headQuarterAdjustmentRateDTO = headQuarterAdjustmentRateDTO;
    }
    /** 허브 코드 조회 별칭. 허브 아이디 === 허브 코드 */
    get id() {
        return this._code;
    }
    set id(value) {
        this._code = value;
    }
    get code() {
        return this._code;
    }
    get validatedMasterId() {
        return validateTextWithHypen(this._masterId);
    }
    /** 허브 이름 */
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get hubNameWithSlashDivider() {
        // 세 가지 데이터 모두 반드시 있는 값
        return addDividerToMultipleTextField([
            this._name,
            this.code,
            this._callcenterCode,
        ]);
    }
    get distributorIdWithSlashDivider() {
        try {
            return addDividerToMultipleTextField([
                this._distributorDTO.name,
                this._distributorId,
            ]);
        }
        catch (error) {
            console.log('[distributorIdWithSlashDivider]', error);
            return '';
        }
    }
    get addCookingTime() {
        return this._addCookingTime;
    }
    set addCookingTime(value) {
        this._addCookingTime = value;
    }
    /**
     * 설정 할증
     * @returns {Boolean}
     */
    get addChargeApplyYn() {
        return this._addChargeApplyYn;
    }
    set addChargeApplyYn(value) {
        this._addChargeApplyYn = value;
    }
    // 상호명
    get validatedBusinessName() {
        return validateTextWithHypen(this._businessName);
    }
    get validatedHubName() {
        return validateTextWithHypen(this.name);
    }
    // 사업자 등록번호
    get validatedBusinessNumber() {
        return validateTextWithHypen(this._businessNumber);
    }
    // 업태
    get validatedBusinessCondition() {
        return validateTextWithHypen(this._businessCondition);
    }
    // 종목
    get validatedBusinessType() {
        return validateTextWithHypen(this._businessType);
    }
    // 이메일
    get validatedCeoEmail() {
        return validateTextWithHypen(this._ceoEmail);
    }
    // (운행설정) 설정 할증 문자열 /(허브관리) 할증대행료
    get formattedAddChargeApplyYn() {
        const lc = 'views.operation_setting.';
        return this.addChargeApplyYn
            ? i18n.t(`${lc}charge_apply`)
            : i18n.t(`${lc}charge_clear`);
    }
    // 추가 할증 정액
    get addDeliveryCharge() {
        return this._addDeliveryCharge;
    }
    set addDeliveryCharge(value) {
        this._addDeliveryCharge = value;
    }
    // 추가 할증 정률
    get addDeliveryChargeRate() {
        return this._addDeliveryChargeRate;
    }
    set addDeliveryChargeRate(value) {
        this._addDeliveryChargeRate = value;
    }
    get deliveryWorkYn() {
        return this._deliveryWorkYn;
    }
    set deliveryWorkYn(value) {
        this._deliveryWorkYn = value;
    }
    /**
     * 추가 할증 정액 + 정률 (운행설정)
     * @returns { string } 추가 할증 정액 + 정률 문자열
     * ( ex: 500원 / 10 % / 1000원 + 10 % )
     */
    get formattedAddDeliveryChargeAndRate() {
        const lc = 'views.operation_setting.';
        return [
            this.addDeliveryCharge,
            this.addDeliveryChargeRate,
        ].reduce((acc, it, index) => {
            if (it <= 0) {
                return acc;
            }
            if (index === 0) {
                acc.push(currency(it));
            }
            if (index === 1) {
                acc.push(i18n.t('unit.percent_suffix', {
                    number: it,
                }));
            }
            return acc;
        }, []).join(' + ') || i18n.t(`${lc}none_delivery_charge`);
    }
    // TODO: 수행상황 legacy (추후 제거 필요)
    get getFulfillmentState() {
        if (this.deliveryWorkYn !== 'Y') {
            return fulfillmentState.STOP;
        }
        if (this.addCookingTime > 0) {
            return fulfillmentState.DELAY;
        }
        return fulfillmentState.GOOD;
    }
    // 수행상황 (운행설정 리뉴얼에서 사용)
    get getFulfillmentStatus() {
        if (this.deliveryWorkYn !== 'Y') {
            return fulfillmentStatus.STOP;
        }
        if (this.addCookingTime > 0) {
            return fulfillmentStatus.DELAY;
        }
        return fulfillmentStatus.GOOD;
    }
    // 수행상황 한글 locale
    get getFulfillmentStateToText() {
        const lc = 'views.operation_setting_dialog.fulfillment_state_';
        switch (this.getFulfillmentState) {
            case fulfillmentState.GOOD:
                return i18n.t(`${lc}good`);
            case fulfillmentState.DELAY:
                return i18n.t(`${lc}delay`, [
                    this.addCookingTime,
                ]);
            case fulfillmentState.STOP:
                return i18n.t(`${lc}stop`);
            default:
                return '';
        }
    }
    /**
     * 추가할증 여부
     * @returns {boolean}
     */
    get isAddDeliveryCharge() {
        return !!(this.addDeliveryChargeRate || this.addDeliveryCharge);
    }
    get useYn() {
        return this._useYn;
    }
    get validatedUseYn() {
        const [hubStatusOption,] = hubStatusOptionList.filter(({ value }) => value === this.useYn);
        return validateTextWithHypen(hubStatusOption.text);
    }
    get formattedWorkingTime() {
        const krTimeString = changeStartEndStringTimeZone(this._workingTime, timeZoneCode.KR);
        return injectSeparatorTimeString(krTimeString);
    }
    get ceoName() {
        return this._ceoName;
    }
    get validatedCeoName() {
        return validateTextWithHypen(this.ceoName);
    }
    get validatedVirtualBankName() {
        return validateTextWithHypen(this._virtualBankDTO?.name);
    }
    // TODO PD 태홍님 확인 필요, 가상계좌 은행이 국민만 있는 게 아니라면 하이픈 처리 뺀다
    // https://www.figma.com/file/NpMitTTPkJeae5S9gvIskz?node-id=208:18325&mode=dev#507066106
    get validatedVirtualBankAccount() {
        return validateTextWithHypen(this._virtualBankDTO?.account);
    }
    get virtualBankWithCommaDivider() {
        const isSlashExist = false;
        return addDividerToMultipleTextField([
            this._virtualBankDTO?.name,
            this._virtualBankDTO?.account,
        ], isSlashExist);
    }
    get validatedWithdrawBankOwner() {
        return validateTextWithHypen(this._withdrawBankDTO?.owner);
    }
    get withdrawBankWithSlashDivider() {
        return addDividerToMultipleTextField([
            this._withdrawBankDTO?.owner,
            this._withdrawBankDTO?.name,
            this._withdrawBankDTO?.account,
        ]);
    }
    get ceoPhone() {
        return this._ceoPhone;
    }
    get formattedCeoPhone() {
        return validateTextWithHypen(formatPhoneNumber(this._ceoPhone));
    }
    get hubRepresentativePhone() {
        return this._hubRepresentativePhone;
    }
    get formattedHubRepresentativePhone() {
        return validateTextWithHypen(formatPhoneNumber(this.hubRepresentativePhone));
    }
    get formattedHubPhone() {
        return validateTextWithHypen(formatPhoneNumber(this._phone));
    }
    get formattedFax() {
        return validateTextWithHypen(formatPhoneNumber(this._fax));
    }
    get convertedAddressInfoToData() {
        return new AddressFormVM({
            siDo: this._addressSiDo,
            siGunGu: this._addressSiGunGu,
            dong: this._addressDong,
            li: this._addressLi,
            jibun: this._addressJibun,
            road: this._addressRoad,
            buildingNumber: this._addressBuildingNumber,
            buildingName: this._addressBuildingName,
            detail: this._addressDetail,
        });
    }
    /** TODO 1.6.0 때 상점정산 주소표기법 수정 시 제거 필요, 사실상 formattedFullAddress과 같은 값
       * BusinessInfo 사업장주소
       */
    get businessInfoAddress() {
        const { siDo, siGunGu, eupMyeonDong, li, jibun, buildingNumber, buildingName, road, detail, } = getAddressData({
            inSiDo: this._addressSiDo,
            inSiGunGu: this._addressSiGunGu,
            inEupMyeonDong: this._addressDong,
            inLi: this._addressLi,
            inJibun: this._addressJibun,
            inRoad: this._addressRoad,
            inBuildingNumber: this._addressBuildingNumber,
            inBuildingName: this._addressBuildingName,
            inDetail: this._addressDetail,
        });
        return [
            siDo,
            siGunGu,
            eupMyeonDong,
            li,
            jibun,
            buildingNumber,
            buildingName,
            road,
            detail,
        ]
            .filter((it) => !!it)
            .join(' ');
    }
    get formattedFullAddress() {
        const addressFormData = new AddressFormVM({
            siDo: this._addressSiDo,
            siGunGu: this._addressSiGunGu,
            dong: this._addressDong,
            li: this._addressLi,
            jibun: this._addressJibun,
            road: this._addressRoad,
            buildingNumber: this._addressBuildingNumber,
            buildingName: this._addressBuildingName,
            detail: this._addressDetail,
        });
        return validateTextWithHypen(addressFormData.formattedAddressBasedOfLi('full'));
    }
    get formattedShortenAddress() {
        const addressFormData = new AddressFormVM({
            dong: this._addressDong,
            li: this._addressLi,
            jibun: this._addressJibun,
            road: this._addressRoad,
            buildingNumber: this._addressBuildingNumber,
            buildingName: this._addressBuildingName,
            detail: this._addressDetail,
        });
        return validateTextWithHypen(addressFormData.formattedAddressBasedOfLi());
    }
    get formattedWithdrawableAmount() {
        return currency(this._withdrawableAmount);
    }
    get formattedDepositBaromoney() {
        return currency(this._depositBaromoney);
    }
    get formattedBaromoney() {
        return currency(this._baromoney);
    }
    get formattedCreatedAt() {
        return formatDate(this._createdAt, dateFormatType.DATE);
    }
    // api상 all, y, n 으로 나와있지만 실제로는 사용/미사용으로 2가지 경우만 가능함
    get formattedHubConfigurationAssignedWorkerCatchYn() {
        try {
            return this._hubConfigurationDTO.assignedWorkerCatchYn === 'Y'
                ? i18n.t('common.use')
                : i18n.t('common.not_use');
        }
        catch (error) {
            console.log('[formattedHubConfigurationAssignedWorkerCatchYn]', error);
            return '-';
        }
    }
    get formattedHubConfigurationShareCallColorType() {
        try {
            if (!this._hubConfigurationDTO.shareCallColorType) {
                return '-';
            }
            const [option,] = shareCallColorTypeOptionList.filter(({ value }) => value === this._hubConfigurationDTO.shareCallColorType);
            return validateTextWithHypen(option.text);
        }
        catch (error) {
            console.log('[formattedHubConfigurationShareCallColorType]', error);
            return '-';
        }
    }
    get validatedHubConfigurationSortByCode() {
        try {
            const [option,] = sortByCodeOptionList.filter(({ value }) => value === this._hubConfigurationDTO.sortByCode);
            return validateTextWithHypen(option.text);
        }
        catch (error) {
            console.log('[validatedHubConfigurationSortByCode]', error);
            return '-';
        }
    }
    get formattedHubConfigurationKilometerProductAllYn() {
        try {
            return this._hubConfigurationDTO.kilometerProductAllYn === 'Y'
                ? i18n.t('common.use')
                : i18n.t('common.not_use');
        }
        catch (error) {
            console.log('[formattedHubConfigurationKilometerProductAllYn]', error);
            return '-';
        }
    }
    // 배달 반경범위(필수값)
    get formattedHubConfigurationKilometerProduct() {
        try {
            return `${this._hubConfigurationDTO.minimumKilometerProduct} ${i18n.t('common.km')} ~ ${this._hubConfigurationDTO.kilometerProduct} ${i18n.t('common.km')}`;
        }
        catch (error) {
            console.log('[formattedHubConfigurationKilometerProduct]', error);
            return '-';
        }
    }
    get formattedWorkerOneClickBaechaYn() {
        if (!this._workerOneClickBaechaYn) {
            return '-';
        }
        const [option,] = workerOneClickBaechaYnOptionList.filter(({ value }) => value === this._workerOneClickBaechaYn);
        return validateTextWithHypen(option.text);
    }
    get formattedHubConfigurationAssignedWorkerLockTime() {
        try {
            const [option,] = assignedWorkerLockTimeOptionList.filter(({ value }) => value === this._hubConfigurationDTO.assignedWorkerLockTime);
            return validateTextWithHypen(option.text);
        }
        catch (error) {
            console.log('[formattedHubConfigurationAssignedWorkerLockTime]', error);
            return '-';
        }
    }
    get formattedHubConfigurationOrderShowTime() {
        try {
            const [option,] = orderShowTimeOptionList.filter(({ value }) => value === this._hubConfigurationDTO.orderShowTime);
            return validateTextWithHypen(option.text);
        }
        catch (error) {
            console.log('[formattedHubConfigurationOrderShowTime]', error);
            return '-';
        }
    }
    get formattedHubConfigurationOptionsIsDoubleClickPrevention() {
        try {
            return this._hubConfigurationDTO.options.isDoubleClickPrevention
                ? i18n.t('common.apply')
                : i18n.t('common.not_applied');
        }
        catch (error) {
            console.log('[formattedHubConfigurationOptionsIsDoubleClickPrevention]', error);
            return '-';
        }
    }
    get formattedHubConfigurationOptionsIsAssignedWorkerCatchHidden() {
        try {
            return this._hubConfigurationDTO.options.isAssignedWorkerCatchHidden
                ? i18n.t('common.available')
                : i18n.t('common.not_available');
        }
        catch (error) {
            console.log('[formattedHubConfigurationOptionsIsAssignedWorkerCatchHidden]', error);
            return '-';
        }
    }
    get formattedHubConfigurationOptionsIsAllocatedAfterCancel() {
        try {
            return this._hubConfigurationDTO.options.isAllocatedAfterCancel
                ? i18n.t('common.available')
                : i18n.t('common.not_available');
        }
        catch (error) {
            console.log('[formattedHubConfigurationOptionsIsAllocatedAfterCancel]', error);
            return '-';
        }
    }
    get formattedLaterUseYn() {
        return this._laterUseYn === 'Y'
            ? i18n.t('common.use')
            : i18n.t('common.not_use');
    }
    get distanceProduct() {
        return this._distanceProduct;
    }
    get formattedDistanceProduct() {
        return distanceProductCodeObj[this.distanceProduct].text;
    }
    get formattedHubConfigurationOptionsIsWorkerSupportAmount() {
        try {
            return this._hubConfigurationDTO.options.isWorkerSupportAmount
                ? i18n.t('common.available')
                : i18n.t('common.not_available');
        }
        catch (error) {
            console.log('[formattedHubConfigurationOptionsIsWorkerSupportAmount]', error);
            return '-';
        }
    }
    get formattedHubConfigurationOptionsIsCustomerMessageService() {
        try {
            const [option,] = isCustomerMessageServiceOptionList.filter(({ value }) => value === this._hubConfigurationDTO.options.isCustomerMessageService);
            return validateTextWithHypen(option.text);
        }
        catch (error) {
            console.log('[formattedHubConfigurationOptionsIsCustomerMessageService]', error);
            return '-';
        }
    }
    get formattedHubConfigurationOptionsIsDeliveryStatus() {
        try {
            return this._hubConfigurationDTO.options.isDeliveryStatus
                ? i18n.t('common.use')
                : i18n.t('common.not_use');
        }
        catch (error) {
            console.log('[formattedHubConfigurationOptionsIsDeliveryStatus]', error);
            return '-';
        }
    }
    get hubAdjustmentRateList() {
        const hubDeliveryMembershipFeeRate = this._hubAdjustmentRateDTO?.hubDeliveryMembershipFeeRate || 0;
        const hubDeliveryFeeRate = this._hubAdjustmentRateDTO?.hubDeliveryFeeRate || 0;
        const headQuarterDeliveryMembershipFeeRate = this._headQuarterAdjustmentRateDTO
            ?.headQuarterDeliveryMembershipFeeRate || 0;
        const headQuarterDeliveryFeeRate = this._headQuarterAdjustmentRateDTO?.headQuarterDeliveryFeeRate || 0;
        const lc = 'views.hub_management_detail.';
        return [
            {
                name: i18n.t(`${lc}delivery_membership_fee_rate`),
                headquarter: `${headQuarterDeliveryMembershipFeeRate} %`,
                distributor: `${100 - (headQuarterDeliveryMembershipFeeRate + hubDeliveryMembershipFeeRate)} %`,
                hub: `${hubDeliveryMembershipFeeRate} %`,
            },
            {
                name: i18n.t(`${lc}delivery_fee_rate`),
                headquarter: `${headQuarterDeliveryFeeRate} %`,
                distributor: `${100 - (headQuarterDeliveryFeeRate + hubDeliveryFeeRate)} %`,
                hub: `${hubDeliveryFeeRate} %`,
            },
        ];
    }
}
